<template>
<div v-if="isShow" class="bg_white pb48">
  <div v-if="!articleResultType">
    <Slider />
    <div class="pl15 pr15">
      <SearchBar  />

      <AttentionArticles
        v-if="attentionArticleLists.length > 0"
        :attention_article_lists="attentionArticleLists"
      />

      <div v-if="articleList.articleThumbnailList.length > 0" class="post mt40">
        <h2 class="title c5a ab">新着コラム</h2>
        <div class="post_list mt48">
          <post v-for="(val, index) in articleList.articleThumbnailList"
            :title="val.title"
            :thumbnail="val.thumbnailImagePath"
            :hashtag="val.tagList"
            :date="val.publicationDate"
            :is_new="val.new"
            :is_ranking="0"
            :id="val.articleId"
            :key="index"
          />
        </div>
        <MoreButton
          :type="'new_column'"
          :currentPageNo="articleList.currentPageNo"
          :hasNext="articleList.hasNext"
          :btnTitle="'もっと見る'"
          @addList="addList"
        />
      </div>

      <HashtagList />

      <AccessRanking />
    </div>
  </div>
  <div v-else class="pl15 pr15">
    <SearchBar class="mt16" />
    <div class="result">
      <div v-if="this.$route.query.resultType == 'hashtag'" class="hashtag">
        <h1 class="result_title rb">{{ this.$route.query.search }}<span class="result_text">に関する記事一覧</span></h1>
      </div>
      <div v-else-if="this.$route.query.resultType == 'search'" class="search">
        <h1 class="result_title rb">「{{ this.$route.query.search }}」の検索結果</h1>
      </div>
    </div>
    <div v-if="tagArticleList.articleThumbnailList.length > 0" class="post_list result_list mt48">
      <post v-for="(val, index) in tagArticleList.articleThumbnailList"
        :title="val.title"
        :thumbnail="val.thumbnailImagePath"
        :hashtag="val.tagList"
        :date="val.publicationDate"
        :is_new="false"
        :is_ranking="0"
        :id="val.articleId"
        :key="index"
      />
    </div>
    <div v-else class="noresult ar">
      検索結果がありませんでした。<br>
      条件を変更して再度検索してください。
    </div>
    <MoreButton
    :type="this.$route.query.resultType"
    :currentPageNo="tagArticleList.currentPageNo"
    :hasNext="tagArticleList.hasNext"
    :btnTitle="'もっと見る'"
    @addList="addList"
    />
  </div>
  <!-- <div class="pl15 pr15">
    <NavigationBar class="mt24" />
  </div> -->

</div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Check from '@/model/getToken'
import Slider from '@/components/fanClub/column/Slider';
import HashtagList from '@/components/fanClub/column/HashtagList';
import PostList from '@/components/fanClub/column/PostList';
import Post from '@/components/fanClub/column/Post';
import MoreButton from '@/components/fanClub/column/MoreButton';
import AccessRanking from '@/components/fanClub/column/AccessRanking';
import AttentionArticles from '@/components/fanClub/column/AttentionArticles';
import TagList from '@/components/api/fanClub/article';
import SearchBar from '@/components/fanClub/column/SearchBar';
import NavigationBar from '@/components/fanClub/column/NavigationBar';
import { mapGetters } from 'vuex';

export default {
  components: {
    Slider,
    HashtagList,
    PostList,
    Post,
    MoreButton,
    AccessRanking,
    SearchBar,
    NavigationBar,
    AttentionArticles,
  },
  data() {
    return {
      isShow: true,
      result: false, // タグ検索か普通の検索の判定用
    }
  },
  methods: {
    // もっと見るボタンタップ時にemitでMoreButtonからデータが返ってくる
    addList(type, nextPageNumber) {
      if(type == 'new_column') {
        this.apiGetArticleList(nextPageNumber);
      }
      if(type == 'search') {
        this.apiSearch(nextPageNumber);
      }
      if(type == 'hashtag') {
        this.apiFindByTag(nextPageNumber);
      }
    },
    // タグ、検索でもっと見るをクリックした時にMoreボタンからのemitで発火
    addTagList(val) {
      this.$store.commit('setTagArticleThumbnailList', val.articleThumbnailList);
      this.$store.commit('setTagArticleCurrenPagetNo', val.currentPageNo);
      this.$store.commit('setTagArticleHasNext', val.hasNext);
    },
    // タグ、検索でもっと見るをクリックした時にMoreボタンからのemitで発火
    addColumnList(val) {
      this.$store.commit('setArticleThumbnailList', val.articleThumbnailList);
      this.$store.commit('setArticleCurrentPageNo', val.currentPageNo);
      this.$store.commit('setArticleHasNext', val.hasNext);
    },
    // 注目記事の一覧をstoreに格納
    addAttentionArticleList(val) {
      this.$store.commit('setAttentionArticleLists', val);
    },
    // 同じページで検索した場合にパラメータが変わっているかを確認
    checkRouter(newSearch, oldSearch) {
      const resultType = this.$route.query.resultType;
      const search = newSearch;
      if(resultType == undefined || newSearch == undefined) return this.$store.commit('setArticleResultType', false);
      if(resultType != '' && newSearch != '') {
        this.$store.commit('setArticleResultType', true);
        if(newSearch != oldSearch) {
          this.$store.commit('resetTagArticleThumbnailList'); // 配列の初期化
          if(resultType == 'hashtag') {
            this.apiFindByTag(1);
          }
          if(resultType == 'search') {
            this.apiSearch(1);
          }
        }
      } else {
        this.$store.commit('setArticleResultType', false);
      }
    },
    // タグ検索
    async apiFindByTag(page) {
      console.log(page);
      let data = {
        page: page,
        tagId: this.$route.query.tagId,
      };
      await TagList.findByTag(data).then((val) => {
        if(page == 1) {
          this.tagArticleList.articleThumbnailList.splice(0, this.tagArticleList.articleThumbnailList.length);
        }

        this.addTagList(val);
      });
    },
    // 新着コラム
    async apiGetArticleList(page) {
      let data = {
        page: page,
      }
      await TagList.getArticleList(data).then((val) => {
        console.log('新着コラム');
        console.log(val);
        this.addColumnList(val);
      });
    },

    // 検索
    async apiSearch(page) {
      let data = {
        page: page,
        q: this.$route.query.search,
      }
      await TagList.search(data).then((val) => {
        if(page == 1) {
          this.tagArticleList.articleThumbnailList.splice(0, this.tagArticleList.articleThumbnailList.length);
        }
        console.log('検索');
        console.log(val);

        this.addTagList(val);
      });
    },

    async apiGetAttentionArticleList() {
      await TagList.getAttentionArticleLists().then((val) => {
        this.addAttentionArticleList(val);
      });
    },
  },
  computed: mapGetters(['articleList', 'tagArticleList', 'articleResultType', 'attentionArticleLists']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });

    if(res) {
      // if(this.tagArticleList.articleThumbnailList.length <= 0) {
        let search = this.$route.query.search;
        if(search == undefined || search == null) {
          search = '';
        }
        this.checkRouter(search, '');
      // }
      /*
      * storeの新着記事の一覧に配列がなければ1ページを取得する（詳細からの戻る対策）
      * 初回読み込み時のみ実行を想定
      */
      if(this.articleList.articleThumbnailList.length <= 0) {
        this.apiGetArticleList(1);
      }
    } else {
      this.isShow = false;
    }
    this.apiGetAttentionArticleList()

  },
  watch: {
    $route(to, from) {
      console.log('url 変更');
      console.log(to);
      console.log(from);
      if(to.query.search != from.query.search || to.query.resultType != from.query.resultType) {
        this.checkRouter(to.query.search, from.query.search);
      }
    },
  },
}
</script>

<style lang="css" scoped>
.hashtag .result_title {
  font-size: 24px;
}
.hashtag .result_text {
  font-size: 16px;
  margin-top: 8px;
}

.search .result_title {
  font-size: 18px;
}

.title {
  text-align: left;
  color: #1DB9B9;
}
.post_list {
  margin-top: 16px;
}

.noresult {
  margin-top: 10px;
  text-align: center;
}

.result {
  margin-top: 40px;
}
.result_title {
  text-align: center;
}
.result_text {
  display: block;
}

.result_list {
  margin-top: 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/column/ColumnList.vue